/**
 * 接口请求地址
 */
export const BASE_URL = '';

/**
 * 错误码
 */
export const CODE = {
  SUCCESS: 0,
  BAD_REQUEST: 11001,
  SERVER_ERROR: 11002,
  UNAUTHORIZED: 20001,
  FORBIDDEN: 11004,
};

/**
 * 错误提示
 */
export const MESSAGE = {
  DEFAULT: '网络错误，请稍后重试',
  UNAUTHORIZED: '请登录',
  FORBIDDEN: '没有此权限，请联系管理员',
};
